import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { toastStore } from './toast-store';
import { ToastItem } from './ToastItem';
import type { ToastItem as ToastItemType } from './types';

const MAX_VISIBLE = 6;

const Container = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

export function Toaster() {
  const [items, setItems] = useState<ToastItemType[]>(() => toastStore.getItems());

  useEffect(() => {
    return toastStore.subscribe(setItems);
  }, []);

  const visible = items.slice(-MAX_VISIBLE);

  if (visible.length === 0) return null;

  return createPortal(
    <Container aria-label="Notificações" role="region">
      {visible.map((item) => (
        <ToastItem key={item.id} item={item} />
      ))}
    </Container>,
    document.body,
  );
}
